export const quotesContainer = () => {
  return {
    container: {
      margin: "-10px",
    },
  };
};
